import { useCallback, useState } from 'react';

import { UserRegisterForm } from './UserRegisterForm';
import { UserRegisterSuccessResult } from './UserRegisterSuccessResult';

export const UserRegister = () => {
  const [phase, setPhase] = useState('init');
  const [userData, setUserData] = useState();

  const handleFormSuccessResult = useCallback((data) => {
    setUserData(data);
    setPhase('success');
  }, []);

  return (
    <>
      {phase === 'init' && (
        <UserRegisterForm onSuccess={handleFormSuccessResult} />
      )}
      {phase === 'success' && <UserRegisterSuccessResult data={userData} />}
    </>
  );
};
